var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-15 0 82.05 89.73"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 41.34h6.16c5.76 0 10.07-1.13 12.93-3.39 2.86-2.26 4.29-5.56 4.29-9.88s-1.2-7.59-3.59-9.67c-2.4-2.08-6.15-3.12-11.26-3.12h-8.52v26.08zM61 27.4c0 9.45-2.97 16.68-8.91 21.69-5.94 5.01-14.38 7.51-25.34 7.51h-8.03v31.24H0V0h28.21c10.71 0 18.85 2.29 24.43 6.88 5.58 4.59 8.37 11.43 8.37 20.52z",
    fill: "#f59c27"
  })));
}
export default SvgP;